const mainSelectStyle = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#ECFDF5" : "transparent",
        fontWeight: "normal",
        fontSize: "14px",
        color: "#545454",
        padding: "6px 20px",
        lineHeight: "1.5",
        "&:hover": {
            backgroundColor: "#ECFDF5",
        },
        cursor: "pointer",
    }),
    menu: (provided) => ({
        ...provided,
        border: "1px solid rgba(0, 0, 0, 0.05)",
        boxShadow: "none",
    }),
    control: (provided) => ({
        ...provided,
        fontWeight: "normal",
        fontSize: "14px",
        borderColor: "rgba(0, 96, 70, 0.25)",
        "&:hover": {
            borderColor: "none",
            boxShadow: "none",
        },
        boxShadow: "none",
        borderRadius: "20px",
        backgroundColor: "#FFFFFF",
        height: "40px",
    }),
    valueContainer: (provided) => ({
        ...provided,
        paddingLeft: "20px",
        whiteSpace: "nowrap",
        color: "#545454",
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "#545454",
        fontSize: "14px",
    }),
    input: (provided) => ({
        ...provided,
        color: "#545454",
        cursor: "text",
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "#B1B1B1",
        boxShadow: "none",
        fontSize: "14px",
    }),
    menuList: (base) => ({
        ...base,
        "::-webkit-scrollbar": {
            width: "4px",
            height: "0px",
        },
        "::-webkit-scrollbar-track": {
            background: "#f1f1f1",
        },
        "::-webkit-scrollbar-thumb": {
            background: "#ccdad1",
        },
        "::-webkit-scrollbar-thumb:hover": {
            background: "rgba(0, 96, 70, 0.25)",
        },
    }),
    indicatorContainer: () => ({
        display: "none",
    }),
};

export default mainSelectStyle;
